var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var AccordionItem = /** @class */ (function (_super) {
    __extends(AccordionItem, _super);
    function AccordionItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccordionItem.prototype.data = function () {
        return {
            isExpanded: this.expanded
        };
    };
    AccordionItem.prototype.mounted = function () {
        this.$parent.$on('expandedItemChanged', this.onExpandedItemChanged);
        this.$emit('expand', this.name);
    };
    AccordionItem.prototype.onExpandedItemChanged = function (name) {
        this.isExpanded = name == this.name;
    };
    AccordionItem.prototype.enter = function (element, done) {
        var targetHeight = element.scrollHeight;
        var percentage = 0;
        var step = function () {
            element.style.maxHeight = "".concat(targetHeight * percentage, "px");
            percentage += 0.1;
            if (percentage < 1) {
                window.requestAnimationFrame(step);
            }
            else {
                done();
                element.style.removeProperty('maxHeight');
            }
        };
        step();
    };
    AccordionItem.prototype.leave = function (element, done) {
        var targetHeight = element.scrollHeight;
        var percentage = 1;
        var step = function () {
            element.style.maxHeight = "".concat(targetHeight * percentage, "px");
            percentage -= 0.1;
            if (percentage > 0) {
                window.requestAnimationFrame(step);
            }
            else {
                done();
                element.style.removeProperty('maxHeight');
            }
        };
        step();
    };
    __decorate([
        Prop({ type: String, default: 'Accordion item' })
    ], AccordionItem.prototype, "title", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], AccordionItem.prototype, "name", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], AccordionItem.prototype, "expanded", void 0);
    AccordionItem = __decorate([
        Component({})
    ], AccordionItem);
    return AccordionItem;
}(Vue));
export default AccordionItem;
